// Fee & Obligation PR-6 — the Explain Engine's policy copy. The D-27/D-28
// owner rulings (2026-07-17) stated as plain fact, no hedging.

export const OBLIGATION_POLICY_COPY = {
  // D-27 — late fees pay 100% to Phoenix as policy (the §17.1 divergence is
  // accepted; BLA text to be aligned later).
  lateFeeToPhoenix:
    "Late fees are paid in full to Phoenix Capital — the borrower's late fee does not go to the seller.",
  // D-28 — unpaid fees stay open obligations, never capitalized into principal
  // (the §17.9 divergence is accepted).
  unpaidFeesStayOpen:
    "Unpaid fees stay open obligations and are collected oldest-first out of future payments — they are never added to the loan's principal balance.",
} as const;

// Human labels for the WS2 anomaly flag codes.
export const ANOMALY_FLAG_LABEL: Record<string, string> = {
  "priority-drift": "Priority order changed",
  "recipient-mismatch": "Recipient mismatch",
  "percentage-deviation": "Amount differs from terms",
  "balance-integrity": "Balance doesn't reconcile",
  "cap-exceeded": "Cap exceeded",
  "stale-no-billing": "No billing channel",
};

// Human labels for the WS3 period-change kinds.
export const PERIOD_CHANGE_LABEL: Record<string, string> = {
  new: "New",
  grown: "Grew",
  shrank: "Shrank",
  stopped: "Stopped",
  unchanged: "Unchanged",
};
